<div class="dashboardContainer">
  <div class="dashboardbgColor" #myElement>
    @if (showDashboardStaticData) {
      <div class="tiles">
        <div class="wrapper">
          <div class="row">
            <div class="col-3">
              <kendo-card class="k-custom-card">
                <kendo-card-header
                  class="k-custom-card-header"
                  >
                  <div>
                    <h3 kendoCardTitle>Risk Severity</h3>
                    <p kendoCardSubtitle class="subtitle">
                      Total Risk & Severity Breakdown
                    </p>
                  </div>
                </kendo-card-header>
                <kendo-card-body class="k-card-body k-custom-card-body k-justify-items-center">
                  <h1 class="date-title" style="color: #9c27b0">10</h1>
                </kendo-card-body>
              </kendo-card>
            </div>
            <div class="col-3 pl-0">
              <kendo-card class="k-custom-card">
                <kendo-card-header
                  class="k-custom-card-header"
                  >
                  <div>
                    <h3 kendoCardTitle>Financial Performance</h3>
                    <p kendoCardSubtitle class="subtitle">
                      Budget vs. Actual Expenditure
                    </p>
                  </div>
                </kendo-card-header>
                <kendo-card-body
                  class="k-custom-card-body"
                  >
                  <div
                    class="wrapper"
                    >
                    <kendo-chart>
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item
                          [visible]="false"
                          [majorGridLines]="{ visible: false }"
                          >
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item
                          [categories]="['Q1 24', 'Q2 24', 'Q3 24', 'Q4 25']"
                          [majorGridLines]="{ visible: false }"
                          >
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
                      <kendo-chart-series>
                        <kendo-chart-series-item
                          type="column"
                          [gap]="2"
                          [spacing]="0"
                          [stack]="true"
                          [data]="[100, 123, 234, 343]"
                          [color]="'#ffc000'"
                          >
                        </kendo-chart-series-item>
                        <kendo-chart-series-item
                          type="column"
                          [data]="[120, 67, 231, 196]"
                          [color]="'#00338D'"
                          >
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                  <div>
                    <span>
                      <kendo-svg-icon
                        style="color: #1971b6"
                        [icon]="minusIcon"
                      ></kendo-svg-icon>
                      <kendo-label text="Budget"> </kendo-label>
                    </span>
                    <span style="padding-left: 10px">
                      <kendo-svg-icon
                        style="color: #ffc000"
                        [icon]="minusIcon"
                      ></kendo-svg-icon>
                      <kendo-label text="Actual Expenditure"> </kendo-label>
                    </span>
                  </div>
                </kendo-card-body>
              </kendo-card>
            </div>
            <div class="col-3 pl-0">
              <kendo-card class="k-custom-card">
                <kendo-card-header
                  class="k-custom-card-header"
                  >
                  <div>
                    <h3 kendoCardTitle>Progress</h3>
                    <p kendoCardSubtitle class="subtitle">Tasks Completed</p>
                  </div>
                </kendo-card-header>
                <kendo-card-body
                  class="k-card-body k-d-flex k-justify-content-around"
                  >
                  <div style="color: #510dbc">
                    <kendo-circulargauge
                      [value]="value"
                      color="#510DBC"
                      [scale]="{ max: 100 }"
                      style="height: 70px; width: 70px; color: #510dbc"
                      >
                      <ng-template
                        kendoCircularGaugeCenterTemplate
                        let-value="value"
                        >
                        {{ value }}%
                      </ng-template>
                    </kendo-circulargauge>
                    <kendo-label
                      text="My Progress"
                      style="display: block; color: #757575"
                      >
                    </kendo-label>
                  </div>
                  <div style="color: #098e7e">
                    <kendo-circulargauge
                      [value]="value"
                      color="#098E7E"
                      [scale]="{ max: 100 }"
                      style="height: 70px; width: 70px; color: #098e7e"
                      >
                      <ng-template
                        kendoCircularGaugeCenterTemplate
                        let-value="value"
                        >
                        {{ value }}%
                      </ng-template>
                    </kendo-circulargauge>
                    <kendo-label
                      text="Total Progress"
                      style="display: block; color: #757575"
                      >
                    </kendo-label>
                  </div>
                </kendo-card-body>
              </kendo-card>
            </div>
            <div class="col-3 pl-0">
              <kendo-card class="k-custom-card">
                <kendo-card-header
                  class="k-custom-card-header"
                  >
                  <div>
                    <h3 kendoCardTitle>Compliance Calendar</h3>
                    <p kendoCardSubtitle class="subtitle">
                      Next Deadline - SOX Report
                    </p>
                  </div>
                </kendo-card-header>
                <kendo-card-body class="k-card-body k-custom-card-body k-justify-items-center">
                  <h1 class="date-title">Dec 21</h1>
                </kendo-card-body>
              </kendo-card>
            </div>
          </div>
        </div>
        <span #anchor class="anchor"></span>
      </div>
    }

    <div class="grid-section" [ngClass]="{'hideStaticData': !showDashboardStaticData}">
      <div class="wrapper">
        <div class="grid-column">
          <div class="grid-shadow">
            <div class="divWrapper" style="justify-content: space-between">
              <label style="color: rgb(24, 58, 181)">Engagements</label>
              <div class="accessible-engagements-switch">
                @if (loggedInUserRole !== userRole.SupportUserRole) {
                  <div
                    class="accessible-engagements-switch"
                    >
                    <kendo-label
                      class="k-display-block switch-label"
                      [for]="switch"
                      text="Accessible Engagements"
                    ></kendo-label>
                    <kendo-switch
                      size="small"
                      #switch
                    (valueChange)="
                      selectViewEngagementAccessibleToCurrentUser($event)
                    "
                      [disabled]="isSwitchDisabled || displayEnagagementLoader"
                    ></kendo-switch>
                  </div>
                }
                <button
                  kendoButton
                  (click)="onRequestEngagementClick()"
                  style="background-color: #00338d; color: white; padding: 6px 16px;">
                  <div class="add-space">
                    <span>+</span>
                    <span>REQUEST A NEW ENGAGEMENT</span>
                  </div>
                </button>
              </div>
            </div>
            <kendo-grid [kendoGridBinding]="engagementList"
              kendoGridSelectBy="engagementId"
              [(selectedKeys)]="mySelection"
              [kendoGridExpandDetailsBy]="expandDetailsBy"
              [(expandedDetailKeys)]="expandedDetailKeys"
              (cellClick)="onCellEngagementClick($event)"
              [selectable]="{ mode: 'multiple', drag: false }"
              [pageSize]="10"
              [pageable]="true"
              [sortable]="true"
              [groupable]="false"
              [reorderable]="false"
              [resizable]="false"
              [filterable]="false"
              [columnMenu]="false"
              class="k-columns-7 grid"
              [loading]="displayEnagagementLoader"
              (detailExpand)="preventExpand($event)">
              <kendo-grid-column field="name"
                title="Engagement"
                [headerStyle]="{ color: '#757575' }"
                [class]="{ 'text-center': true }"
                               [style]="{
                color: '#183AB5',
                cursor: 'pointer',
                padding: '0px 10px 0px 10px'
              }"
                [resizable]="false"
                [width]="230">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="ellipse"
                    kendoTooltip
                    filter="span"
                    >
                    <span class="ellipse" title="{{ dataItem.name }}">
                      {{ dataItem.name }}
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="engagementStatusId"
                title="Status"
                [headerStyle]="{ color: '#757575' }"
                [class]="{ 'text-center': true }"
                [style]="{ color: '#757575', padding: '0px 10px 0px 10px' }"
                [resizable]="false"
                [width]="130">
                <ng-template kendoGridCellTemplate let-dataItem>
                  @if (dataItem.engagementStatusId === 1) {
                    <span class="center-align p-i-0-2">
                      <kendo-svg-icon style="color: #37b400"
                        [icon]="starIcon">
                      </kendo-svg-icon>
                      <span class="text-centered p-t-2-px">
                        Active
                      </span>
                    </span>
                  }
                  @if (dataItem.engagementStatusId === 2) {
                    <span class="center-align p-i-0-2">
                      <kendo-svg-icon style="color: #59b0f6"
                        [icon]="snowFlakeIcon">
                      </kendo-svg-icon>
                      <span class="text-centered p-t-2-px">
                        Frozen
                      </span>
                    </span>
                  }
                  @if (dataItem.engagementStatusId === 3) {
                    <span class="center-align p-i-0-2">
                      <kendo-svg-icon style="color: #757575"
                        [icon]="cancelCircleIcon">
                      </kendo-svg-icon>
                      <span class="text-centered p-t-2-px">
                        Cancelled
                      </span>
                    </span>
                  }
                  @if (dataItem.engagementStatusId === 4) {
                    <span class="center-align p-i-0-2">
                      <kendo-svg-icon style="color: #cd93d7"
                        [icon]="checkCircleIcon">
                      </kendo-svg-icon>
                      <span class="text-centered p-t-2-px">
                        Complete
                      </span>
                    </span>
                  }
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="plannedStartDate"
                title="Start Date"
                [headerStyle]="{ color: '#757575' }"
                [class]="{ 'text-center': true }"
                [style]="{ color: '#757575', padding: '0px 10px 0px 10px' }"
                [resizable]="false"
                [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div style="padding-left: 10px">
                    {{ dataItem.plannedStartDate | kendoDate : "MM/dd/yyyy" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="modifiedDate"
                title="Last Updated"
                [headerStyle]="{ color: '#757575' }"
                [class]="{ 'text-center': true }"
                [style]="{ color: '#757575', padding: '0px 10px 0px 10px' }"
                [resizable]="false"
                [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div style="padding-left: 10px">
                    {{ dataItem.modifiedDate | kendoDate : "MM/dd/yyyy" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="plannedEndDate"
                title="End Date"
                [headerStyle]="{ color: '#757575' }"
                [class]="{ 'text-center': true }"
                [style]="{ color: '#757575', padding: '0px 10px 0px 10px' }"
                [resizable]="false"
                [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div style="padding-left: 10px">
                    {{ dataItem.plannedEndDate | kendoDate : "MM/dd/yyyy" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="contact"
                title="Primary Contact"
                [headerStyle]="{ color: '#757575' }"
                [class]="{ 'text-center': true }"
                [style]="{ color: '#757575', padding: '0px 10px 0px 10px' }"
                [resizable]="false"
                [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem class="k-d-flex">
                  <span style="display: inline-flex; align-items: center;gap:12px;padding-inline:0.6rem">
                    <kendo-svg-icon [ngStyle]="{width: (dataItem.contact.length <= 25 ? 15 : 15) + 'px'}"
                      style="color: #183ab5; cursor: pointer;"
                      [icon]="envelopIcon"
                      (click)="openEmail(dataItem.email)" title="Send Email">
                    </kendo-svg-icon>
                  <p style="
                      margin-right: 0px;
                      float: right;
                      word-break: break-all;
                    ">
                      {{ dataItem.contact }}
                    </p>
                  </span>
                </ng-template>
              </kendo-grid-column>
              @if (loggedInUserRole === userRole.SupportUserRole) {
                <kendo-grid-column field="remove"
                  title=""
                  [width]="50"
                  [class]="{ 'text-center': true }"
                  [style]="{ padding: '0px 10px 0px 10px' }"
                  [resizable]="false"
                  [filterable]="false"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <kendo-svg-icon style="padding: 16px; color: black; cursor: pointer"
                      [icon]="xCircle"
                    (click)="onDeleteIconClick(dataItem)"></kendo-svg-icon>
                  </ng-template>
                  <ng-template kendoGridFilterMenuTemplate
                    let-filter
                    let-column="column"
                    let-filterService="filterService">
                    <kendo-grid-string-filter-menu [column]="column"
                      [filter]="filter"
                      [filterService]="filterService"
                      [extra]="false">
                      <kendo-filter-contains-operator></kendo-filter-contains-operator>
                    </kendo-grid-string-filter-menu>
                  </ng-template>
                </kendo-grid-column>
              }

              <ng-template kendoGridDetailTemplate let-dataItem>
                <kendo-grid [kendoGridBinding]="getDistinctModules(dataItem.modules)"
                  (cellClick)="onCellModuleClick($event, dataItem)"
                  [pageable]="false"
                  [sortable]="false"
                  [filterable]="false"
                  [groupable]="false"
                  [hideHeader]="true"
                  scrollable="none"
                  class="k-p-0 k-grid">
                  <kendo-grid-column field="name"
                    [headerStyle]="{ color: '#757575' }"
                    [class]="{ 'text-center': true }"
                    [resizable]="false"
                    class="k-p-0"
                                   [style]="{
                      color: '#183AB5',
                      cursor: 'pointer',
                    }"
                    [width]="213">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <div class="ellipse"
                        kendoTooltip
                        filter="span"
                        >
                        <span class="ellipse" title="{{ dataItem.name }}">
                          {{ dataItem.name }}
                        </span>
                      </div>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column field="activeFlag"
                    [headerStyle]="{ color: '#757575' }"
                    [class]="{ 'text-center': true }"
                                   [style]="{
                      color: '#757575',
                    }"
                    [resizable]="false"
                    class="k-p-0"
                    [width]="130">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      @if (dataItem.activeFlag === false) {
                        <span>
                          <kendo-svg-icon style="padding: 17px; color: #40b0a6"
                            [icon]="starIcon">
                          </kendo-svg-icon>
                          Active
                        </span>
                      }
                      @if (dataItem.activeFlag === true) {
                        <span>
                          <kendo-svg-icon style="padding: 17px; color: #b55dc4"
                          [icon]="checkCircleIcon"></kendo-svg-icon>
                          Frozen
                        </span>
                      }
                    </ng-template>
                  </kendo-grid-column>

                  <!-- <kendo-grid-column field="plannedStartDate"
                  title="Start Date"
                  [headerStyle]="{ color: '#757575' }"
                  [class]="{ 'text-center': true }"
                                   [style]="{
                    color: '#757575',
                    padding: '0px 10px 0px 10px'
                  }"
                  [resizable]="false"
                  class="k-p-0"
                  [width]="120">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.plannedStartDate | kendoDate : "MM/dd/yyyy" }}
                  </ng-template>
                </kendo-grid-column> -->

                <kendo-grid-column field="modifiedDate"
                  title="Last Updated"
                  format="{0:d}"
                  [headerStyle]="{ color: '#757575' }"
                  [class]="{ 'text-center': true }"
                                   [style]="{
                    color: '#757575',
                    padding: '0px 10px 0px 10px'
                  }"
                  [resizable]="false"
                  class="k-p-0"
                  [width]="120">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <div style="padding-left: 10px">
                      {{ dataItem.modifiedDate | kendoDate : "MM/dd/yyyy" }}
                    </div>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="plannedEndDate"
                  title="End Date"
                  [format]="{ date: 'short' }"
                                   [headerStyle]="{
                    color: '#757575',
                    padding: '0px 10px 0px 10px'
                  }"
                  [class]="{ 'text-center': true }"
                  [style]="{ color: '#757575' }"
                  [resizable]="false"
                  class="k-p-0"
                  [width]="120">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.plannedEndDate | kendoDate : "MM/dd/yyyy" }}
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="moduleCount"
                  title="Task"
                  [headerStyle]="{ color: '#757575' }"
                  [class]="{ 'text-center': true }"
                                   [style]="{
                    color: '#757575',
                    padding: '0px 10px 0px 10px'
                  }"
                  [resizable]="false"
                  class="k-p-0"
                  [width]="90">
                </kendo-grid-column>

                <kendo-grid-column field="contact"
                  title="Primary Contact"
                  [class]="{ 'text-center': true }"
                  [style]="{ padding: '0px 10px 0px 10px' }"
                  [resizable]="false"
                  class="k-p-0"
                  [width]="200">
                </kendo-grid-column>
                @if (loggedInUserRole === userRole.SupportUserRole) {
                  <kendo-grid-column field="remove"
                    title=""
                    [width]="50"
                    [class]="{ 'text-center': true }"
                    [style]="{ padding: '0px 10px 0px 10px' }"
                    [resizable]="false"
                    [filterable]="false"
                    >
                  </kendo-grid-column>
                }
              </kendo-grid>
            </ng-template>
            <ng-template kendoGridNoRecordsTemplate>
              @if (!displayEnagagementLoader) {
                <div>No records available</div>
              }
            </ng-template>
            <ng-template kendoGridLoadingTemplate>
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                size="default"
                color="#225EFF"
                type="ball-triangle-path" [fullScreen]="false">
              </ngx-spinner>
            </ng-template>
            <ng-template kendoPagerTemplate
              let-totalPages="totalPages"
              let-currentPage="currentPage">
              <div class="pager-container">
                <div class="pager-content">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-numeric-buttons [buttonCount]="pagerSettings.buttonCount"></kendo-pager-numeric-buttons>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  <kendo-pager-info></kendo-pager-info>
                  <kendo-pager-page-sizes [pageSizes]="pagerSettings.pageSizes"></kendo-pager-page-sizes>
                  <kendo-svgicon [icon]="refresh"
                    class="right-align pointer"
                    (click)="loadEngagements()"
                  title="Refresh the Grid"></kendo-svgicon>
                </div>
              </div>
            </ng-template>
          </kendo-grid>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Engagement Request popup component -->
<app-engagementrequest
  [openRequestEngagementPopup]="isRequestEngagementPopupOpen"
  (closeEvent)="onRequestEngagementPopupClose()"
  [anchor]="anchor"
  [margin]="margin"
  >
</app-engagementrequest>

<app-remove-engagement
  [openEngRemovalRequestPopup]="openRemoveEngPopup"
  [engRemovalData]="selectedRemoveEng"
  (closeEvent)="closeRemoveEngPopup()"
  [anchor]="anchor"
></app-remove-engagement>

@if (isEngagementAccessRequestOpen) {
  <app-engagementaccessrequest
    [isEngagementAccessRequestOpen]="isEngagementAccessRequestOpen"
    (closeEvent)="closeEngagementAccessRequestPopup($event)"
  ></app-engagementaccessrequest>
}

@if (openUserRequestPopup) {
  <app-useraddrequest
    [openUserRequestPopup]="openUserRequestPopup"
    [isEngagementAccessRequired]="true"
    (closeEvent)="openUserRequestPopup = false"
    [anchor]="anchor"
  ></app-useraddrequest>
}
</div>
